export const DEFAULT_UPDATE_ERROR = {
  description: {
    id: 'defaultError.description',
    defaultMessage: 'Please try again later or contact us.',
  },
};
